import { render } from "./SubstanceTab.vue?vue&type=template&id=2a6616ce"
import script from "./SubstanceTab.vue?vue&type=script&lang=js"
export * from "./SubstanceTab.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__